import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_plus_sign_jax_d366b403a64b23e261064e5c4f865648",
  "use": "ico_plus_sign_jax_d366b403a64b23e261064e5c4f865648-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico_plus_sign_jax_d366b403a64b23e261064e5c4f865648\">\n<path d=\"M7.19531 4.79492H12V7.19531H7.19531V12H4.79492V7.19531H0V4.79492H4.79492V0H7.19531V4.79492Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol